//Package
import { defineComponent } from "vue";

// Assets
import IconPlus from "@/assets/images/icons/IconPlus";
import IconDelete from "@/assets/images/icons/IconDelete";
import IconCancel from "@/assets/images/icons/IconCancel";
import IconNext from "@/assets/images/icons/IconNext";
import IconCheck from "@/assets/images/icons/IconCheck";
import IconDownload from "@/assets/images/icons/IconDownload";

export default defineComponent({
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    variant: {
      type: String,
      required: true,
      default: "",
    },
    onlyIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    reverIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    pill: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    colorIcon: {
      type: String,
      required: false,
      default: 'white'
    }
  },
  components: {
    IconPlus,
    IconDelete,
    IconCancel,
    IconNext,
    IconCheck,
    IconDownload,
  },
  computed: {
    cssProps() {
      const generalStyles = {
        "--rounded": this.pill ? "20px" : this.onlyIcon ? "200px" : this.small ? "4px" : "8px",
        "--margin-left": this.onlyIcon || this.reverIcon ? "0" : "0.75rem",
        "--margin-right": this.reverIcon && !this.onlyIcon ? "0.75rem" : "0",
        "--padding-button": this.onlyIcon ? "0" : "0.5rem 1rem",
        "--flex-direction": this.reverIcon ? "row-reverse" : "row",
        "--min-width": this.onlyIcon ? "40px" : "auto",
        "--font-size": this.small ? "16px" : "18px",
        "--font-weight": this.small ? "500" : "700",
        "--height": this.small ? "32px" : "40px",
        "--line-height": this.small ? "20px" : "24px",
      };
      const objStyles = {
        primary: {
          "--bg-color": "#5D5FEF",
          "--bg-color-hover": "#7A7CFF",
          "--bg-color-pressed": "#1719DA",
          "--bg-color-disabled": "#ECEFF1",
          "--border": "1px solid transparent",
          "--border-disabled": "solid transparent",
          "--color-text": "#FFFFFF",
          "--color-text-disabled": "#B0BEC5",
          "--color-text-pressed": "#FFFFFF",
        },
        secondary: {
          "--bg-color": "#FFFFFF",
          "--bg-color-hover": "#ECECFF",
          "--bg-color-pressed": "#C9CAFF",
          "--bg-color-disabled": "#FFFFFF",
          "--border": "1px solid #5D5FEF",
          "--border-disabled": "solid #B0BEC5",
          "--color-text": "#5D5FEF",
          "--color-text-disabled": "#B0BEC5",
          "--color-text-pressed": "#1719DA",
        },
        flat: {
          "--bg-color": "#FFFFFF",
          "--bg-color-hover": "#ECECFF",
          "--bg-color-pressed": "#C9CAFF",
          "--bg-color-disabled": "#FFFFFF",
          "--border": "1px solid transparent",
          "--border-disabled": "solid transparent",
          "--color-text": "#5D5FEF",
          "--color-text-disabled": "#B0BEC5",
          "--color-text-pressed": "#1719DA",
        },
        danger: {
          "--bg-color": "#DA1414",
          "--bg-color-hover": "#FFABAB",
          "--bg-color-pressed": "#AC0000",
          "--bg-color-disabled": "#FFFFFF",
          "--border": "1px solid transparent",
          "--border-disabled": "solid transparent",
          "--color-text": "#FFFFFF",
          "--color-text-disabled": "#B0BEC5",
          "--color-text-pressed": "#FFFFFF",
        },
        dashed: {
          "--bg-color": "#FFFFFF",
          "--bg-color-hover": "#ECECFF",
          "--bg-color-pressed": "#C9CAFF",
          "--bg-color-disabled": "#FFFFFF",
          "--border": "0.75px dashed #5D5FEF",
          "--border-disabled": "0.75px dashed #B0BEC5",
          "--color-text": "#5D5FEF",
          "--color-text-disabled": "#B0BEC5",
          "--color-text-pressed": "#1719DA",
        },
      };
      return { ...objStyles[this.variant], ...generalStyles };
    },
    isDisabled() {
      return !!this.disabled;
    },
    colorFill() {
      return this.disabled ? "#B0BEC5" : this.colorIcon ? this.colorIcon : "white";
    }
  }
});
